import { z } from 'zod';

export const loginFormSchema = z.object({
  email: z.email('E-mail inválido'),
  password: z.string().min(4, 'Senha inválida'),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;
